// src/lib/schema/components/WebsiteSchema.tsx

import React from 'react';
import { generateWebsiteSchema, schemaToString } from '@/lib/schema';

/**
 * Interface for page data
 */
interface PageData {
  title?: string;
  description?: string;
  lastModified?: string;
  datePublished?: string;
  rating?: number;
  reviewCount?: number;
  [key: string]: any;
}

/**
 * Props for the WebsiteSchema component
 */
interface WebsiteSchemaProps {
  lang: string;
  pageData?: PageData;
}

/**
 * Component that renders the JSON-LD schema for the website
 */
export function WebsiteSchema({ lang, pageData = {} }: WebsiteSchemaProps): React.ReactElement | null {
  const websiteSchema = generateWebsiteSchema(lang, pageData);
  const jsonLdString = schemaToString(websiteSchema);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: jsonLdString }}
    />
  );
}